import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatRupiah } from "@/lib/constants";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { BookOpen } from "lucide-react";

export default function DailyCashBook() {
  const [accounts, setAccounts] = useState([]);
  const [account, setAccount] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [data, setData] = useState({ opening_before: 0, rows: [] });

  useEffect(() => {
    api.get("/cash/accounts").then(({ data }) => { const a = (data || []).filter((x) => x.active !== false); setAccounts(a); if (!account && a.length) setAccount(a[0].id); }).catch(() => {});
  }, []); // eslint-disable-line

  const load = useCallback(async () => {
    if (!account) return;
    try { const { data } = await api.get("/cash/daybook", { params: { account_id: account, date_from: dateFrom, date_to: dateTo } }); setData(data || { opening_before: 0, rows: [] }); } catch (e) { /* ignore */ }
  }, [account, dateFrom, dateTo]);
  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <h1 className="font-heading text-xl font-bold text-[#111827] sm:text-2xl"><BookOpen size={26} className="mr-2 inline text-[#3B82F6]" />Buku Kas Harian</h1>
      <p className="mt-1 text-sm text-gray-500">Laporan (read-only) dari Cash & Bank Ledger · Opening + In − Out ± Transfer = Closing</p>

      <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-3">
        <Select value={account} onValueChange={setAccount}>
          <SelectTrigger data-testid="daybook-account" className="h-9"><SelectValue placeholder="Pilih akun" /></SelectTrigger>
          <SelectContent>{accounts.map((a) => <SelectItem key={a.id} value={a.id}>{a.account_name} ({a.type})</SelectItem>)}</SelectContent>
        </Select>
        <Input data-testid="daybook-from" type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} className="h-9" />
        <Input data-testid="daybook-to" type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} className="h-9" />
      </div>

      <div className="mt-3 rounded-lg border border-gray-100 bg-white p-3 text-sm shadow-sm">
        <div className="flex justify-between"><span className="text-gray-500">Saldo Awal (sebelum periode)</span><span className="font-bold text-[#111827]">{formatRupiah(data.opening_before)}</span></div>
      </div>

      <div className="mt-3 space-y-2">
        {data.rows.map((r) => (
          <div key={r.date} data-testid={`daybook-row-${r.date}`} className="rounded-lg border border-gray-100 bg-white p-3 shadow-sm">
            <div className="flex items-center justify-between"><span className="text-sm font-semibold text-gray-800">{r.date}</span><span className="text-sm font-bold text-[#8a6d1a]">Closing {formatRupiah(r.closing)}</span></div>
            <div className="mt-1 grid grid-cols-2 gap-x-3 gap-y-0.5 text-[11px] text-gray-500 sm:grid-cols-3">
              <span>Opening: <span className="font-medium text-gray-700">{formatRupiah(r.opening)}</span></span>
              <span>Cash In: <span className="font-medium text-emerald-700">{formatRupiah(r.cash_in)}</span></span>
              <span>Cash Out: <span className="font-medium text-red-600">{formatRupiah(r.cash_out)}</span></span>
              {r.transfer_in > 0 && <span>Transfer In: <span className="font-medium text-blue-700">{formatRupiah(r.transfer_in)}</span></span>}
              {r.transfer_out > 0 && <span>Transfer Out: <span className="font-medium text-indigo-700">{formatRupiah(r.transfer_out)}</span></span>}
            </div>
          </div>
        ))}
        {data.rows.length === 0 && <p className="py-10 text-center text-sm text-gray-400">Belum ada transaksi pada periode ini.</p>}
      </div>
    </div>
  );
}
